<template>
  <q-layout view="hHh lpR fFf" style="height:100vh;">
    <q-page-container>
        <q-page class="bg-black">
          <q-header
            :class="startKrack ? 'bg-krach text-white': 'bg-black text-white'"
            reveal
            elevated
          >
            <q-toolbar class="q-pa-sm">
              <q-toolbar-title>
                <div class="row">
                  <div class="col-2">
                    <!--<img src="/img/Logo_Original_Blanc_100px.png" class="q-pl-md q-pt-sm" />-->
                  </div>
                  <div class="col-3 q-pt-md text-uppercase text-center">
                    {{ clock.time }}
                  </div>
                  <div class="col-2 q-pt-sm text-center">
                    <img src="/img/Logo_Original_Blanc_100px.png" width="100" height="50"/>
                  </div>
                  <div class="col-3 q-pt-sm text-uppercase text-center" />
                  <div class="col-2 q-pt-md text-uppercase text-subtitle1 text-center text-weight-bold">
                    session bar : {{seance.code_acces}}
                  </div>
                </div>
              </q-toolbar-title>
            </q-toolbar>
          </q-header>
          <div class="trading-content row text-white">
            <div style="width:100%;" class="grid gap-4 q-mx-xl q-px-lg" :class="categoriesClasses">
              <div v-for="(category, index) in categories" :key="category.id" class="q-mt-xl column items-center">
                <span
                  class="text-h5 text-weight-bold text-italic"
                  :class="colors[index]"
                >
                  {{ category.name }}
                </span>
                <div class="column q-pt-md" v-if="category.drinks.length <= 5">
                  <div v-for="drink in category.drinks" :key="drink.id" class="col q-pt-xs q-mb-xs">
                    <transition-group
                      appear
                      enter-active-class="animated animate__headShake"
                    >
                      <DrinkVisu
                        :key="drink.optimized_price + drink.difference + drink.id"
                        :drink="drink"
                      />
                    </transition-group>
                  </div>
                </div>
                <div class="q-pt-md row justify-between" v-else>
                  <div class="q-pr-xl drinks-half">
                    <!-- 
                        Get first half of drinks rounded to superior integer
                        if even length of drinks ex : 11 -> 6 , 5
                                                       7 -> 4 , 3
                    -->
                    <div v-for="drink in category.drinks.slice(0,Math.ceil((category.drinks.length)/2))" :key="drink.id" class="col q-pt-xs q-mb-xs">
                      <transition-group
                        appear
                        enter-active-class="animated animate__headShake"
                      >
                        <DrinkVisu
                          :key="drink.optimized_price + drink.difference + drink.id"
                          :drink="drink"
                        />
                      </transition-group>
                    </div>
                  </div>
                  <div class="drinks-half">
                    <div v-for="drink in category.drinks.slice(Math.ceil((category.drinks.length)/2))" :key="drink.id" class="col q-pt-xs q-mb-xs">
                      <transition-group
                        appear
                        enter-active-class="animated animate__headShake"
                      >
                        <DrinkVisu
                          :key="drink.optimized_price + drink.difference + drink.id"
                          :drink="drink"
                        />
                      </transition-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <q-page-sticky
            :class="startKrack ? 'footer-toolbar bg-krach': 'footer-toolbar'"
            expand
            position="bottom"
          >
            <marquee
              v-if="actus"
              :duration="50"
              :repeat="10"
              :paused="isPaused"
            >
              <div class="marquee-content" v-for="actu in actus" :key="actu.id">
                <div class="flex">
                  <span v-html=actu.content></span>
                  <q-icon v-if="actu.icon" class="q-pl-sm" :name="actu.icon" :color="actu.iconColor" size="sm"/>
                </div>
              </div>
            </marquee>
          </q-page-sticky>
        </q-page>
    </q-page-container>
    <krack-dialog
      :show="showKrackDialog"
      :start="startKrack"
    />
  </q-layout>
</template>

<script>

import ReconnectingEventSource from "reconnecting-eventsource";
import KrackDialog from '~/components/KrackDialog';
import Marquee from '~/components/Marquee';
import { getAllDrinksAnonymousByCatBySeance } from '~/services/drinks';
import { getAnonymousSeanceById, getNewsBySession } from '~/services/seances';
import { baseUrl, base_url_seances } from '~/variables';
import DrinkVisu from '../components/DrinkVisu.vue'

export default {
  name: "Visu",
  components: {
    KrackDialog,
    Marquee,
    DrinkVisu
  },
  data() {
    return {
      actus: [],
      clock: {
        time: ''
      },
      isPaused: false,

      colors: ['text-green-4', 'text-pink-4', 'text-light-blue-4', 'text-yellow-4', 'text-orange-4', 'text-red-4'],
      categories: [],
      idSeance: null,
      showKrackDialog: false,
      startKrack: false,
      seance: {},
      es: null
    };
  },  
  async created() {
    // clock
    this.updateTime()
    // load session
    this.idSeance = this.$route.params.idSeance
    let response = await getAnonymousSeanceById(this.idSeance)
    if (response.status == 200) {
      this.seance = response.data
    }
    // load session drinks
    response = await getAllDrinksAnonymousByCatBySeance(this.idSeance)
    if (response.status === 200) {
      this.categories = response.data.map(category => {
        category.drinks = category.drinks.map(e => {
          return {...e, difference: 0.00}
        })
        console.log(category)
        return category
      })
      this.categories.sort((a, b) => a.rank - b.rank)
    }

    response = await getNewsBySession(this.idSeance)
    if (response.status === 200) {
      this.actus = response.data
    }
  },
  mounted() {
    this.setupStreams()
  },
  destroyed () {
    this.es.close()
  },
  computed: {
    categoriesClasses() {
      const categoriesLength = this.categories.length
      console.log(categoriesLength)
      if (categoriesLength <= 2) {
        return 'grid-cols-1'
      }
      if (categoriesLength <= 4) {
        return 'grid-cols-2'
      }
      return 'grid-cols-3'
    }
  },
  methods: {
    setupStreams() {
      this.esCurrentSession = new ReconnectingEventSource(`${baseUrl}${base_url_seances}/${this.idSeance}/events/`)
      this.esGeneric = new ReconnectingEventSource(`${baseUrl}${base_url_seances}/events/`)

      this.addSessionListeners()
      this.addNewsListeners()
    },
    addSessionListeners() {
      this.esCurrentSession.addEventListener('command', event => {
        let data = JSON.parse(event.data)
        const prices = data.consommation_set.map(e => e.price * e.quantite)
        let price = prices.reduce((accumulator, currentValue) => accumulator + currentValue)
        price = Number.parseFloat(price).toFixed(2)
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: `Nouvelle commande: ${price} € `,
          position: 'top-right',
        })
      }, false)
      this.esCurrentSession.addEventListener('update', event => {
        const data = JSON.parse(event.data)
        data.map( priceHistory => {
          for (const category of this.categories) {
            const index = category.drinks.findIndex(drink => drink.id === priceHistory.drink.id)
            if (index !== -1) {
              const oldPrice = category.drinks[index].current_price
              const difference = (((priceHistory.price / oldPrice) * 100) - 100)
              this.$set(category.drinks, index , {...priceHistory.drink, difference})
              break
            }
          }
        })
      }, false)
      this.esCurrentSession.addEventListener('krach_start', event => {
        this.startKrack = true
        this.toggleKrackDialog()
        setTimeout(() => this.toggleKrackDialog(), 4000)
      }, false)
      this.esCurrentSession.addEventListener('krach_stop', event => {
        this.startKrack = false
        this.toggleKrackDialog()
        setTimeout(() => this.toggleKrackDialog(), 4000)
      }, false)
      /*
      this.esCurrentSession.addEventListener('addDrink', event => {
        const data = JSON.parse(event.data)
        this.categories = this.categories.map(cat => {
          if (cat.id === data.category_id) {
            cat.drinks.push(data)
          }
          return cat
        })
      }, false)
      this.esCurrentSession.addEventListener('updateDrink', event => {
        const data = JSON.parse(event.data)
        this.categories = this.categories.map(cat => {
          if (cat.id === data.category_id) {
            const drinks = cat.drinks.map(drink => {
              if (drink.id === data.id) {
                return data
              }
              return drink
            })
            cat.drinks = drinks
            return cat
          }
        })
      }, false)
      this.esCurrentSession.addEventListener('deleteDrink', event => {
        const data = JSON.parse(event.data)
        this.categories = this.categories.map(cat => {
          if (cat.id === data.category_id) {
            cat.drinks = cat.drinks.filter(drink => drink.id !== data.id)
          }
          return cat
        })
      }, false)
      */
    },
    addNewsListeners() {
      this.esCurrentSession.addEventListener('deleteNews', event => {
        const data = JSON.parse(event.data)
        this.deleteNews(data)
      })
      this.esCurrentSession.addEventListener('updateNews', event => {
        const data = JSON.parse(event.data)
        this.updateNews(data)
      })
      this.esCurrentSession.addEventListener('createNews', event => {
        const data = JSON.parse(event.data)
        this.updateNews(data)
      })
      this.esGeneric.addEventListener('deleteNews', event => {
        const data = JSON.parse(event.data)
        this.deleteNews(data)
      })
      this.esGeneric.addEventListener('updateNews', event => {
        const data = JSON.parse(event.data)
        this.updateNews(data)
      })
      this.esGeneric.addEventListener('createNews', event => {
        const data = JSON.parse(event.data)
        this.updateNews(data)
      })
    },
    toggleKrackDialog() {
      this.showKrackDialog = !this.showKrackDialog
    },
    updateTime() {
      let cd = new Date()
      this.clock.time = this.zeroPadding(cd.getHours(), 2) +
        ':' + this.zeroPadding(cd.getMinutes(), 2) +
        ':' + this.zeroPadding(cd.getSeconds(), 2)
    },
    zeroPadding(num, digit) {
      let zero = ''
      for(let i = 0; i < digit; i++) {
        zero += '0'
      }
      return (zero + num).slice(-digit)
    },
    updateNews(data) {
      this.actus = this.actus.map(actu => {
        if (actu.id === data.id) {
          return data
        }
        return actu
      })

      if (!this.actus.find(actu => actu.id === data.id)) {
        this.addNews(data)
      }
    },
    deleteNews(data) {
      this.actus = this.actus.filter(actu => actu.id !== data.id)
    },
    addNews(data) {
      this.actus.push(data)
    }
  },
}
</script>
<style lang="scss" scoped>
.q-layout{
  font-family: 'Montserrat';
}
.q-header, .footer-toolbar{
  border-style: solid;
  border-width: 2px;
  border-image: linear-gradient(to left, rgba(0, 0, 0, 1) 1%, #7B7B7B 50%, rgba(0, 0, 0, 1) 100%) 
                100% 0 100% 0/2px 0 2px 0 stretch;
}
.trading-content{
  height: 80vh;
  background:  
  url("../../public/svg/Vector 1.svg") left/auto 20% no-repeat, 
  url("../../public/svg/Vector 2.svg") right/auto 20% no-repeat;
}
.animated{
  animation-duration: 2s;
}
.footer-toolbar{
  padding-top: 15px;
  padding-bottom: 15px;
  color: #ffffff;
  background-color: #000000;
}
.bg-krach{
  background: rgb(221,44,0);
  background: linear-gradient(0deg, rgba(221,44,0,1) 0%, rgba(255,112,67,1) 35%, rgba(191,54,12,1) 100%);
}
.marquee-content{
  display: inline-block;
  padding: 10px 45px 0 45px;
  border-right: 1px solid #676767;
}
.responsive-top-margin{
  @media screen and (min-width:  1023px) {
    margin-top: 10vh;
  }
}
.drinks-half {
  // max-width: 50%;
}
</style>